'use strict';

import { userRegistrationRootState } from './user-registration.states';
import { RegistrationFormComponent } from './registrationForm/registrationForm.component';

export const UserRegistrationModuleLazy = angular.module('mx.sb.UserRegistrationLazy', []).component(userRegistrationRootState.component, RegistrationFormComponent);
